import React from 'react'
import { HeroSection, type HeroSectionVariant } from '@/components/HeroSection'

export type HeroSectionBlockProps = {
  title: string
  subtitle?: string | null
  variant?: HeroSectionVariant | null
  stats?: Array<{ value: string; label: string }> | null
  blockType: 'heroSection'
}

export const HeroSectionBlock: React.FC<HeroSectionBlockProps> = ({
  title,
  subtitle,
  variant,
  stats,
}) => {
  return (
    <HeroSection
      title={title}
      subtitle={subtitle || undefined}
      variant={variant || undefined}
      stats={stats || undefined}
    />
  )
}
